var map = {
	"./atualidades-e-negocios/3.jpg": [
		169,
		2
	],
	"./celebridades-e-tv/3.jpg": [
		170,
		5
	],
	"./criancas-e-quadrinhos/3.jpg": [
		171,
		8
	],
	"./decoracao-e-jardinagem/3.jpg": [
		172,
		11
	],
	"./especializadas/3.jpg": [
		173,
		14
	],
	"./esportes/3.jpg": [
		174,
		17
	],
	"./estilo-de-vida-e-moda/3.jpg": [
		175,
		20
	],
	"./games-e-tecnologia/3.jpg": [
		176,
		23
	],
	"./gastronomia-e-receitas/3.jpg": [
		177,
		26
	],
	"./historia-e-educacao/3.jpg": [
		178,
		29
	],
	"./saude-e-bem-estar/3.jpg": [
		179,
		32
	],
	"./viagens-e-lazer/3.jpg": [
		180,
		35
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 100;
module.exports = webpackAsyncContext;